import Vue from "vue";
import store from "@/store";
import { getSchema } from "@/api/configs";

const pageNum = 80;

/**
 * 获取基本数据
 */
const getBasicData = (param) => {
    return new Promise(async (resolve, reject) => {
        //  定义初始搜索参数
        let optons = {
            from: store.state.search.pictureProducer,
            shape: store.state.search.pictureSize,
            type: "all",
            page: 1,
            per_page: pageNum,
            orderby: store.state.search.checkCondition,
            lang: store.state.global.currentLang.lang,
            folderIds: store.state.search.searchCondition.folderIds,
        };
        //  当前数据类型是否为按语言
        store.state.mixins.isLangType = true;

        let newOptons = Object.assign(optons, param);
        let { data } = await getSchema("search", newOptons);
        resolve(data);
    });
};

/**
 * 搜索
 */
const getSearchResult = (param) => {
    return new Promise(async (resolve, reject) => {
        //  定义初始搜索参数
        let optons = {
            from: store.state.search.pictureProducer,
            shape: store.state.search.pictureSize,
            type: "all",
            page: 1,
            per_page: pageNum,
            orderby: store.state.search.checkCondition,
        };
        //  当前数据类型是否为按语言
        store.state.mixins.isLangType = true;
        let newOptons = Object.assign(
            optons,
            store.state.search.searchCondition,
            param
        );

        let { data } = await getSchema("search", newOptons);
        resolve(data);
    });
};
/**
 * 最新更新
 */
const getLatestUpdateSchema = async (param) => {
    return new Promise(async (resolve, reject) => {
        //  定义处理最新更新参数
        let optons = {
            from: store.state.search.pictureProducer,
            shape: store.state.search.pictureSize,
            type: "all",
            page: 1,
            per_page: pageNum,
            orderby: store.state.search.checkCondition,
            fnames: store.state.search.filterCondition,
            lang: store.state.global.isNewBeveliver //  如果为新人账号，添加当前语言字段
                ? store.state.global.currentLang.lang
                : null,
        };

        let newOptons = Object.assign(optons, param);
        let { data } = await getSchema("latest-update", newOptons);

        resolve(data);
    });
};

const getFavoritePicturesSchema = async (param) => {
    return new Promise(async (resolve, reject) => {
        //  定义处理最新更新参数
        let optons = {
            // from: V.$P.pictureProducer,  //  暂时隐藏图片来源
            favorite_id: store.state.favorites.favoritesId,
            shape: store.state.search.pictureSize,
            type: "all",
            page: 1,
            per_page: pageNum,
            orderby: store.state.search.favoritePictureSort,
        };

        let newOptons = Object.assign(optons, param);
        let { data } = await getSchema("favorites/medias", newOptons);

        resolve(data);
    });
};

export {
    getBasicData,
    getSearchResult,
    getLatestUpdateSchema,
    getFavoritePicturesSchema,
};
